module.exports = __webpack_public_path__ + "img/dice-four.9893d03c.svg";